	/**生成一個隨機數**/
	function randomNum(min, max) {
                return Math.floor((new Date()).getTime() * (max - min) + min);
            }
	/**生成一個隨機色**/
	function randomColor(min, max) {
                var r = randomNum(min, max);
                var g = randomNum(min, max);
                var b= randomNum(min, max);
                return "rgb(" + r + "," + g + "," + b + ")";
            }
	/**繪制驗證碼圖片**/
	function drawPic(parSrc) {
                var canvas = document.getElementById("canvas");
                var width = canvas.width;
                var height = canvas.height;
                //獲取該canvas的2D繪圖環境 
                var ctx = canvas.getContext('2d'); 
                ctx.textBaseline ='bottom';
                /**繪制背景色**/
                ctx.fillStyle = randomColor(180,240);
                //顏色若太深可能導致看不清
                ctx.fillRect(0,0,width,height);
                /**繪制文字**/
                var str ='ABCEFGHJKLMNPQRSTWXY123456789';
        　　　　 var code="";
        　　　　　//生成四個驗證碼
                for(var i=1;i<=4;i++) {
                    if(parSrc == undefined)
                    var txt = str[randomNum(0,str.length)];
                    else
                    var txt = parSrc.substring(i-1,i);
                    code=code+txt;
                    ctx.fillStyle = randomColor(50,160);
                    //隨機生成字體顏色
                    ctx.font = randomNum(18,32) +'px SimHei';
                    //隨機生成字體大小
                    var x =10 +i *25;
                    var y = randomNum(25,35);
                    var deg = randomNum(0,45);
                    //修改坐標原點和旋轉角度
                    ctx.translate(x, y); 
                    ctx.rotate(deg * Math.PI /180); 
                    ctx.fillText(txt,0,0);
                    //恢復坐標原點和旋轉角度
                    ctx.rotate(-deg * Math.PI /180);
                    ctx.translate(-x, -y);
                }
                
                /**繪制幹擾線**/
                for(var i=0;i<0;i++) {
                    ctx.strokeStyle = randomColor(40, 180);
                    ctx.beginPath();
                    ctx.moveTo(randomNum(0,width/2), randomNum(0,height/2));
                    ctx.lineTo(randomNum(0,width/2), randomNum(0,height));
                    ctx.stroke();
                }
                /**繪制幹擾點**/
                for(var i=0;i <30;i++) {
                    ctx.fillStyle = randomColor(255);
                    ctx.beginPath();
                    ctx.arc(randomNum(0, width), randomNum(0, height),1,0,2* Math.PI);
                    ctx.fill();
                }
            }

    function callVerify() {        
        var ajax_url = sessionStorage.getItem('VcUrl').replace("undefined","") + 'Sso/verifyCode'

        $.ajax({
            url: ajax_url,
            type: 'POST',
            error: function(){
                console.log('error');
            },
            success: function(e){

                $("#codeimage").attr("src", "data:image/jpg;base64,"+e.isPass);
                $('#isPass').val(e.SecretKey);
                
            }
        });

    }